var _jsxFileName = "/opt/atlassian/pipelines/agent/build/src/components/utility/Main/index.tsx";
import React from 'react';
import { VStack } from '@adc/parallax-component-library';
const Main = ({
  ...props
}) => {
  const isDvhSupported = CSS?.supports?.('height', '1dvh');
  return /*#__PURE__*/React.createElement(VStack, Object.assign({
    backgroundColor: "$surface.background",
    style: [{
      minHeight: '-webkit-fill-available',
      height: isDvhSupported ? '100dvh' : '100vh'
    }]
  }, props, {
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 9,
      columnNumber: 5
    }
  }));
};
export { Main };